//@ts-check
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import { ContainerContext } from '../../../utils';
import searchEcVersions from '../actions/searchEcVersions';

/** @param {import('@action-types/ecVersion').EcVersionsQueryOptions<import('@action-types/ecVersion').SearchVersionDetails>} options */
const useEcVersions = ({ appVersionList, pageSize, pageIndex, type, ...options }) => {
  const { ims } = useContext(ContainerContext);
  const token = ims?.getAccessToken()?.token;
  const enabled = Boolean(appVersionList?.length && token && (options.enabled ?? true));

  const data = useQuery({
    ...options,
    enabled,
    queryKey: ['get-ec-versions', appVersionList, pageSize, pageIndex, type, token],
    queryFn: async ({ signal }) =>
      searchEcVersions({
        token,
        signal,
        appVersionList,
        type,
      }),
  });

  return data;
};

export default useEcVersions;
